export default __webpack_public_path__ + "static/media/logo.a85ac625.png";